import {ItemCountView} from '../../../../shared/scripts/ui_canvas_engine/ItemCountView'
import {UIGamePlayerInformationKnightView} from '../../../../shared/scripts/ui_game/ui_game_cities_and_knights/UIGamePlayerInformationKnightView'
import {UIGameSpriteHandler} from '../../../../shared/scripts/UIGameSpriteHandler'
import {Sprites} from '../../../../shared/scripts/ui_game/UIGameImageDictionary'

export class UIWGamePlayerInformationKnightView extends UIGamePlayerInformationKnightView {
    protected createMyKnightStateView() {
        const playerInformationW = this.playerInformation.width
        const playerInformationH = this.playerInformation.height

        const knightIconX = playerInformationW * 0.809
        const knightIconY = playerInformationH * 0.71
        const knightIconW = playerInformationW * 0.0804
        const knightIconH = playerInformationH * 0.22

        const knightIconCountX = playerInformationW * 0.8943
        const knightIconCountY = knightIconY
        const knightIconCountW = playerInformationW * 0.1
        const knightIconCountH = knightIconH

        const texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_swords)
        const iconPadding = -knightIconW * 0.0786
        this.knightStrengthView = new ItemCountView(knightIconX, knightIconY, knightIconW, knightIconH, this.playerInformation, texture,
            knightIconCountX, knightIconCountY, knightIconCountW, knightIconCountH, iconPadding)
        this.knightStrengthView.resetTextYPosition()
    }

    protected createOpponentKnightView() {
        const playerInformationW = this.playerInformation.width
        const playerInformationH = this.playerInformation.height

        const knightIconX = playerInformationW * 0.809
        const knightIconY = playerInformationH * 0.5545
        const knightIconW = playerInformationW * 0.0804
        const knightIconH = playerInformationH * 0.341

        const knightIconCountX = playerInformationW * 0.8943
        const knightIconCountY = knightIconY
        const knightIconCountW = playerInformationW * 0.1
        const knightIconCountH = knightIconH

        const iconPadding = -knightIconW * 0.0786
        this.knightStrengthView = new ItemCountView(knightIconX, knightIconY, knightIconW, knightIconH, this.playerInformation, UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_swords),
            knightIconCountX, knightIconCountY, knightIconCountW, knightIconCountH, iconPadding)
        this.knightStrengthView.resetTextYPosition()
    }
}
